import React, { useEffect } from 'react'
import { Accordion, Modal } from "react-bootstrap";
import './You_Are_Almost_There_Modal.css'
import { useNavigate } from 'react-router-dom';

const You_Are_Almost_There_Modal = (props) => {

    const navigate = useNavigate()

    useEffect(() => {
        
        const timer = setTimeout(() => {

            console.log("navigate",props?.navigate)

            if (props?.navigate) {
                navigate(props.navigate); 
            } else if (props?.onHide) {
                props.onHide(); 
            }
        }, 3000);

        return () => clearTimeout(timer); 
    }, [navigate, props.navigate, props.onHide]);

    return (
        <section>

            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="You_Are_Almost_There_Modal modal-holder"
            >

                <Modal.Body>
                    <div className='main_container'>
                        <p className='title'>{props.text}</p>

                        <div className='img_holder'>
                            <img src='\assets\Image\offcanvas\modal_img.png' className='img' />
                        </div>

                    </div>
                </Modal.Body>
            </Modal>

        </section>
    )
}

export default You_Are_Almost_There_Modal
